import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { FalconComplaintDecisionType } from "@/enums/falcon/complaints/falcon-complaint-decision-type.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint decision type filter
 */
export const falconComplaintDecisionTypeFilter: CustomFilter = {
  falconComplaintDecisionType(value: any): string {
    value = +value as FalconComplaintDecisionType;
    if (value === FalconComplaintDecisionType.None) {
      value = i18n.t(I18nMessageKey.SharedFiltersComplaintDecisionTypeNoneText);
    } else if (value === FalconComplaintDecisionType.Positive) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintDecisionTypePositiveText
      );
    } else if (value === FalconComplaintDecisionType.Negative) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersComplaintDecisionTypeNegativeText
      );
    } else {
      value = "";
    }
    return value;
  }
};
